import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1 className='text-center p-5'>page not found</h1>
        </div>
    );
};

export default NotFound;